import React from "react";
import {
    withRouter
} from "react-router-dom";
import logo from '../../assets/jwt-io.svg';
import './home.scss';
import axios from 'axios';
import CONSTANTS from "../../constants";
import Cookies from 'universal-cookie';

interface ConversationPanelProps{
    location:any,
    history:any
}
type Props = ConversationPanelProps
const cookies = new Cookies();

class Home extends React.Component<Props> {
    private apiServer = CONSTANTS.api_server;
    state = {
        did: '',
        token:''
    };

    componentDidMount(): void {
        if(this.props.location.state){
            const session_id = this.props.location.state.data;
            //should check cookie for further
            if(session_id){
                this.pollServer(session_id)
            }else{
                this.props.history.push({pathname:'/'})
            }
        }else{
            //check for cookie
            //get session id
            const session_id = cookies.get('session_id');
            if(session_id){
                console.log("session id found from cookie", session_id);
                this.pollServer(session_id)
            }else{
                console.log("no session id found from cookie");
                this.props.history.push({pathname:'/'})
            }
        }

    }

    pollServer = (session_id: string, count:number = 0) => {
        console.log(count);
        axios.get(`${this.apiServer}/getTokenData?session_id=${session_id}`).then(res => {
            if(res.data.success){
                this.setState({
                    did:res.data.data.payload.did,
                    token:res.data.data.id_token
                });
                cookies.set('session_id', session_id, { path: '/home' });
            }else{
                if(res.data.error === "JWT validity has expired"){
                    setTimeout(() => {
                        if(count < 60){
                            this.pollServer(session_id, count+1)
                        }
                    },1000)
                }else{
                    this.props.history.push({pathname:'/'})
                }
            }
        })
    };

    onLogout = () => {
        cookies.remove('session_id', { path: '/home' } );
        this.props.history.push({pathname:'/'})
    };

    render() {
        return (
            <div className="container-fluid d-flex flex-column align-items-center home-wrapper">
                <div className="header">
                    <h1>Relying Party App Using DID-SIOP</h1>
                </div>
                <div className="underline"></div>
                <div className="d-flex justify-content-center">
                    <div className="d-flex flex-column align-items-center success-message">
                        <h4>Congratulations ! You are successfully authorized to this App</h4>
                        <div className="d-flex flex-column justify-content-center align-items-center identity">
                            <p><b>Your DID</b></p>
                            <p><span className="text-muted">{this.state.did}</span></p>
                        </div>
                        <div className="jwt-io">
                            <a href={`https://jwt.io/#id_token=${this.state.token}`} target="_blank" rel="noreferrer">
                                <img src={logo} alt="jwt io badge"/>
                            </a>
                        </div>
                        <div className="d-flex flex-column align-items-center justify-content-center logout-btn">
                            <button className="btn btn-success btn-large" onClick={this.onLogout}>Logout</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

// @ts-ignore
export default withRouter(Home);
